import {observer} from 'mobx-react';
import React, {CSSProperties} from 'react';

type Props = {
    url: string;
    alt: string;
    border?: boolean;
    backgroundImage?: string;
    imgStyle?: CSSProperties;
};

export const StandardSlide = observer(({url, alt, border, backgroundImage, imgStyle}: Props) => {
    return (
        <div
            style={{
                border: border ? '1px solid silver' : undefined,
                backgroundImage: backgroundImage || undefined,
            }}
        >
            <picture>
                <source
                    type="image/webp"
                    srcSet={url.replace('.png', '.webp').replace('.jpg', '.webp')}
                />
                <img
                    src={url}
                    alt={alt}
                    width={75}
                    height={75}
                    style={imgStyle}
                />
            </picture>
        </div>
    );
});
